import { tv } from "@/utils/tv.config";

export const cardMediaClasses = tv({
  base: ["aspect-video"],
  variants: {
    position: {
      top: [],
      middle: [],
      bottom: [],
    },
    isMedia: {
      true: ["w-full"],
    },
  },
});
